import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'pcln-design-system'
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from 'pcln-icons'
import styled from 'styled-components'

const RoundButton = styled(Button)`
  border-radius: 50%;
  height: 40px;
  width: 40px;
  padding-top: 8px;
  padding-right: 0;
  padding-bottom: 8px;
  padding-left: 0;
`

const iconLookup = {
  up: ArrowUp,
  down: ArrowDown,
  left: ArrowLeft,
  right: ArrowRight
}

const ArrowButton = props => {
  const ArrowIcon = iconLookup[props.direction] || ArrowLeft
  return (
    <RoundButton {...props} disabled={props.disabled} onClick={props.onClick}>
      <ArrowIcon
        name={props.direction}
        alt={props.direction + ' button'}
        title={props.direction + ' icon'}
        titleId={props.direction + '-id'}
      />
    </RoundButton>
  )
}

ArrowButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  direction: PropTypes.oneOf(['up, down, left, right'])
}

ArrowButton.displayName = 'ArrowButton'

export default ArrowButton
